import { render, staticRenderFns } from "./ArquivosOuvidoria.vue?vue&type=template&id=07d29380&scoped=true"
import script from "./ArquivosOuvidoria.vue?vue&type=script&lang=ts"
export * from "./ArquivosOuvidoria.vue?vue&type=script&lang=ts"
import style0 from "./ArquivosOuvidoria.vue?vue&type=style&index=0&id=07d29380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d29380",
  null
  
)

export default component.exports